/**
 * CUSTOMIZATIONS:
 * - Sostituito messaggio di login con redirect alla homepage
 * - Aggiunta la traduzione in italiano dei messaggi
 * - Aggiunta a monte la condizione per spidLogin in caso di attivazione
 *
 * @module components/theme/Unauthorized/Unauthorized
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import { useIntl, defineMessages } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import { getBaseUrl, BodyClass } from '@plone/volto/helpers';
import {
  Icon,
  LoginButton,
  RemoveBodyClass,
} from 'design-comuni-plone-theme/components/ItaliaTheme';

import config from '@plone/volto/registry';
/**
 * unauthorized function.
 * @function Unauthorized
 * @returns {string} Markup of the unauthorized page.
 */

const messages = defineMessages({
  unauthorized_description: {
    id: 'unauthorized_description',
    defaultMessage:
      'La pagina che stai cercando non è disponibile o è stata rimossa.',
  },
  unauthorized_text: {
    id: 'unauthorized_text',
    defaultMessage: 'Torna alla {page} per continuare la navigazione.',
  },
  unauthorized_homepage: {
    id: 'unauthorized_homepage',
    defaultMessage: 'pagina principale',
  },
});

const Unauthorized = () => {
  // const error_message = useSelector((state) => state.apierror.message);
  const intl = useIntl();
  let location = useLocation();

  return (
    <Container className="view-wrapper">
      <BodyClass className="public-ui" />
      <RemoveBodyClass className="cms-ui" />
      <h1>
        <FormattedMessage id="Unauthorized" defaultMessage="Unauthorized" />
      </h1>
      <h2 className="h3">
        {intl.formatMessage(messages.unauthorized_description)}
      </h2>
      <p className="description">
        {intl.formatMessage(messages.unauthorized_text, {
          page: (
            <Link to={'/'}>
              {intl.formatMessage(messages.unauthorized_homepage)}
            </Link>
          ),
        })}
        <br />

        {config.settings.siteProperties.spidLogin && (
          <FormattedMessage
            id="You are trying to access a protected resource, please {login} first."
            defaultMessage="You are trying to access a protected resource, please {login} first."
            values={{
              login: (
                <>
                  <FormattedMessage
                    id="login_spid_message"
                    defaultMessage="login with Spid"
                  />
                  <div className="unauthorized-spid-login">
                    <LoginButton size="big">
                      <span className="rounded-icon">
                        <Icon
                          color="primary"
                          icon="it-user"
                          padding={false}
                          size=""
                        />
                      </span>
                      <span>
                        <FormattedMessage
                          id="login_with_spid"
                          defaultMessage="Login with Spid"
                        />
                      </span>
                    </LoginButton>
                  </div>
                  <FormattedMessage
                    id="login_admin_message"
                    defaultMessage="or login as an administrator"
                  />{' '}
                  <Link to={`${getBaseUrl(location.pathname)}/login`}>
                    <FormattedMessage id="log in" defaultMessage="log in" />
                  </Link>
                </>
              ),
            }}
          />
        )}
      </p>
      {/*
      Rimosso perchè la form di contatto è stata disabilitata
      <p>
        <FormattedMessage
          id="If you are certain you have the correct web address but are encountering an error, please contact the {site_admin}."
          defaultMessage="If you are certain you have the correct web address but are encountering an error, please contact the {site_admin}."
          values={{
            site_admin: (
              <Link to="/contact-form">
                <FormattedMessage
                  id="Site Administration"
                  defaultMessage="Site Administration"
                />
              </Link>
            ),
          }}
        />
      </p> */}
      <p>
        <FormattedMessage id="Thank you." defaultMessage="Thank you." />
      </p>
    </Container>
  );
};

export default withServerErrorCode(401)(Unauthorized);
